<section class="page-container" (input)="preserveZero($event)">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Payment Status</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="content-container">
    <section class="content-container">
      <h2 class="sub-heading w-full border-b">Search</h2>
      <div class="grid grid-cols-1 gap-4 px-4 py-4 md:grid-cols-2">
        <div *ngFor="let field of searchBooking" class="min-w-0">
          <label [for]="field.id" class="font-bold">{{
            field.label
          }}</label>
          <app-search-input
            class="block w-full"
            [id]="field.id"
            [dataInput]="field.value ?? ''"
            [isButtonActive]="true"
            [lock]="isSaving || isSearching"
            (dataOutput)="field.value = $event"
            (clickSearch)="searchField(field)"
            (focusout)="searchOnBlur(field, $event)"
          />
        </div>
      </div>
    </section>
    <ul class="tabs-container payment-tabs">
      <li
        (click)="selectedTab = 'Balance'"
        [ngClass]="
          selectedTab == 'Balance' ? 'tab-item_selected' : 'tab-item'
        "
      >
        Balance of Payment
      </li>
      <li
        (click)="selectedTab = 'Buyer'"
        [ngClass]="
          selectedTab == 'Buyer' ? 'tab-item_selected' : 'tab-item'
        "
      >
        Buyer's Account
      </li>
      <li
        (click)="selectedTab = 'Sales'"
        [ngClass]="
          selectedTab == 'Sales' ? 'tab-item_selected' : 'tab-item'
        "
      >
        Sales Consultant's Account
      </li>
      <li
        (click)="selectedTab = 'komoco'"
        [ngClass]="
          selectedTab == 'komoco' ? 'tab-item_selected' : 'tab-item'
        "
      >
        Komoco's Account
      </li>
      <li
        (click)="selectedTab = 'Others'"
        [ngClass]="
          selectedTab == 'Others' ? 'tab-item_selected' : 'tab-item'
        "
      >
        Others
      </li>
    </ul>

    <fieldset
      class="content-container__tabs w-full min-w-0"
      [disabled]="isSaving || isSearching"
    >
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Balance' || selectedTab == '')"
      >
        <h2 class="sub-heading w-full border-b">
          Details of Contract
        </h2>
        <app-data-form
          [dataFields]="buyersDetailsForm"
          [dataName]="'buyersDetailsForm'"
          (updateFields_child)="updateFields($event)"
        />
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Balance' || selectedTab == '')"
      >
        <h2 class="sub-heading w-full border-b">
          Due Amount from Buyer
        </h2>
        <app-data-form
          [dataFields]="detailsCashDiscount"
          [dataName]="'detailsCashDiscount'"
          (updateFields_child)="updateFields($event)"
        />
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Balance' || selectedTab == '')"
      >
        <h2 class="sub-heading w-full border-b">
          Adjustment Amounts
        </h2>
        <div
          class="w-full overflow-x-auto"
          *ngIf="lastSearchResult?.GvAdjustmentsGrid?.length"
        >
          <app-data-table
            class="block min-w-[40rem]"
            [tableHeaders]="adjustmentHeaders"
            [tableEntries]="lastSearchResult?.GvAdjustmentsGrid || []"
          />
        </div>
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Balance' || selectedTab == '')"
      >
        <h2 class="sub-heading w-full border-b">
          Rebates from Komoco
        </h2>
        <app-data-form
          [dataFields]="detailsOtherFees"
          [dataName]="'detailsOtherFees'"
          (updateFields_child)="updateFields($event)"
        />
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Balance' || selectedTab == '')"
      >
        <h2 class="sub-heading w-full border-b">
          Rebates from Trade-In Vehicle
        </h2>
        <app-data-form
          [dataFields]="detailsInsurance"
          [dataName]="'detailsInsurance'"
          (updateFields_child)="updateFields($event)"
        />
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Balance' || selectedTab == '')"
      >
        <h2 class="sub-heading w-full border-b">Total Rebates</h2>
        <app-data-form
          [dataFields]="detailsHireApplication"
          [dataName]="'detailsHireApplication'"
          (updateFields_child)="updateFields($event)"
        />
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Balance' || selectedTab == '')"
      >
        <h2 class="sub-heading w-full border-b">
          Total Amount Received
        </h2>
        <div
          class="w-full overflow-x-auto"
          *ngIf="filteredDataTotalAmountReceived.length"
        >
          <app-data-table
            class="block min-w-[44rem]"
            [tableHeaders]="tableHeadersTotalAmountReceived"
            [tableEntries]="filteredDataTotalAmountReceived"
          ></app-data-table>
        </div>
        <app-data-form
          [dataFields]="totalAmountReceivedForm"
          [dataName]="'totalAmountReceivedForm'"
          (updateFields_child)="updateFields($event)"
        />
      </div>

      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Balance' || selectedTab == '')"
      >
        <h2 class="sub-heading w-full border-b">
          Details of Hire Purchase Application
        </h2>
        <div
          class="grid grid-cols-1 gap-x-8 px-4 py-4 text-sm md:grid-cols-2 lg:gap-x-14 lg:px-8"
        >
          <div class="flex min-w-0 flex-col gap-4">
            <label
              *ngFor="
                let field of detailsTradeInVehicle;
                let index = index
              "
              class="flex w-full flex-col items-start lg:flex-row lg:items-center"
            >
              <span class="w-full font-bold md:pr-2 lg:w-1/3">{{
                field.label
              }}</span>
              <div class="flex w-full min-w-0 lg:w-2/3">
                <app-select-input
                  *ngIf="field.type === 'select'"
                  class="block w-full"
                  [id]="field.id"
                  [dataInput]="field.value"
                  [selectOptions]="field.options || []"
                  [lock]="busy"
                  (dataOutput)="updateHireField(field, $event)"
                />
                <ng-container *ngIf="field.type !== 'select'">
                  <app-text-input
                    class="block min-w-0 flex-1"
                    [id]="field.id"
                    dataType="number"
                    [dataInput]="field.value ?? ''"
                    [step]="0.01"
                    [lock]="!!field.lock || isSaving || isSearching"
                    (dataOutput)="updateHireField(field, $event)"
                  />
                  <span
                    *ngIf="
                      field.id === 'LoanPeriod' ||
                      field.id === 'LoanRate'
                    "
                    class="hire-unit"
                  >
                    {{ field.id === "LoanPeriod" ? "Months" : "%" }}
                  </span>
                </ng-container>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Balance' || selectedTab == '')"
      >
        <h2 class="sub-heading w-full border-b">Payment Status</h2>
        <app-data-form
          [dataFields]="additionalRemarks"
          [dataName]="'additionalRemarks'"
          (updateFields_child)="updateFields($event)"
        />
      </div>

      <div [hidden]="selectedTab !== 'Buyer'">
        <div
          class="w-full overflow-x-auto"
          *ngIf="lastSearchResult?.BuyerAccessoriesGrid?.length"
        >
          <app-data-table
            class="block min-w-[40rem]"
            [tableHeaders]="tableHeadersKomocoItems"
            [tableEntries]="
              lastSearchResult?.BuyerAccessoriesGrid || []
            "
          />
        </div>
      </div>
      <app-data-form
        [hidden]="!(selectedTab == 'Buyer')"
        [dataFields]="detailsVehicle"
        [dataName]="'detailsVehicle'"
        (updateFields_child)="updateFields($event)"
      />
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Sales')"
      >
        <div
          class="w-full overflow-x-auto"
          *ngIf="lastSearchResult?.SalesmanAccessoriesGrid?.length"
        >
          <app-data-table
            class="block min-w-[40rem]"
            [tableHeaders]="tableHeadersKomocoItems"
            [tableEntries]="
              lastSearchResult?.SalesmanAccessoriesGrid || []
            "
          />
        </div>
        <app-data-form
          [dataFields]="buyersDetails"
          [dataName]="'buyersDetails'"
          (updateFields_child)="updateFields($event)"
        />
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Sales')"
      >
        <div
          class="w-full overflow-x-auto"
          *ngIf="lastSearchResult?.SalesmanReceivedGrid?.length"
        >
          <app-data-table
            class="block min-w-[40rem]"
            [tableHeaders]="salesmanReceiptHeaders"
            [tableEntries]="
              lastSearchResult?.SalesmanReceivedGrid || []
            "
          />
        </div>
        <app-data-form
          [dataFields]="buyersDetailsSalesSummary"
          [columns]="1"
          [dataName]="'buyersDetailsSalesSummary'"
          (updateFields_child)="updateFields($event)"
        />
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'komoco')"
      >
        <div
          class="w-full overflow-x-auto"
          *ngIf="filteredDataKomocoItems.length"
        >
          <app-data-table
            class="block min-w-[44rem]"
            [tableHeaders]="tableHeadersKomocoItems"
            [tableEntries]="filteredDataKomocoItems"
          ></app-data-table>
        </div>
        <app-data-form
          [dataFields]="detailsVehicle5"
          [dataName]="'detailsVehicle5'"
          (updateFields_child)="updateFields($event)"
        />
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Others')"
      >
        <h2 class="sub-heading w-full border-b">Short Payment</h2>
        <app-data-form
          [dataFields]="detailsVehicle2"
          [dataName]="'detailsVehicle2'"
          (updateFields_child)="updateFields($event)"
        />
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Others')"
      >
        <h2 class="sub-heading w-full border-b">
          Hire Purchase Settlement
        </h2>
        <app-data-form
          [dataFields]="detailsVehicle3"
          [dataName]="'detailsVehicle3'"
          (updateFields_child)="updateFields($event)"
        />
        <p class="px-4 text-sm">
          {{ lastSearchResult?.DateSubmitted }}
        </p>
      </div>
      <div
        class="content-container"
        [hidden]="!(selectedTab == 'Others')"
      >
        <h2 class="sub-heading w-full border-b">Cheques Issued</h2>
        <div
          class="w-full overflow-x-auto"
          *ngIf="filteredDataChequesIssued.length"
        >
          <app-data-table
            class="block min-w-[44rem]"
            [tableHeaders]="tableHeadersChequesIssued"
            [tableEntries]="filteredDataChequesIssued"
          ></app-data-table>
        </div>
        <p
          *ngIf="!filteredDataChequesIssued.length"
          class="px-4 py-4 text-sm"
        >
          No cheques issued
        </p>
      </div>
    </fieldset>
    <div
      class="mt-4 flex w-full flex-col flex-wrap gap-1 md:w-fit md:flex-row"
    >
      <button
        class="shorter-btn misc-btn"
        [disabled]="!hasContract || busy"
        (click)="saveRecord()"
      >
        <fa-icon [icon]="faSave" class="mr-1" />Save
      </button>
      <button
        class="shorter-btn misc-btn"
        [disabled]="!hasContract || busy"
        (click)="printPaymentStatus()"
      >
        <fa-icon [icon]="faPrint" class="mr-1" />Print Payment Status
      </button>
      <button
        class="shorter-btn misc-btn"
        [disabled]="!hasContract || busy"
        (click)="fullDocsSumitted()"
      >
        <fa-icon [icon]="faSave" class="mr-1" />Full Docs Submitted
      </button>
      <button
        class="shorter-btn misc-btn"
        [disabled]="!hasContract || busy"
        (click)="printParfSettlement()"
      >
        <fa-icon [icon]="faPrint" class="mr-1" />Print PARF Settlement
      </button>
      <button
        class="shorter-btn clear-btn"
        [disabled]="isSaving"
        (click)="clear()"
      >
        <fa-icon [icon]="faTrash" class="mr-1" />Clear
      </button>
      <button
        class="shorter-btn misc-btn"
        [disabled]="busy"
        (click)="toInvoice()"
      >
        <fa-icon [icon]="faChain" class="mr-1" />To Invoice
      </button>
    </div>
  </div>
</section>
